export const barOption={
    color: ['#264D73', '#84B5D5', '#19B3E8'],
    legend: {},
    title: {
        text: 'Awesome Chart'
    },
    grid: {
        show:false,
        left: '3%',
        right: '5%',
        width:'auto',			
    },
    xAxis: {
        type: 'category'
    },
    yAxis: [{
            type: 'value',
            splitLine:{
                show:false
            },
            name: '单位 万辆',
            axisLabel: {
                formatter: '{value}'
            }
        },
        {
            type: 'value',
            splitLine:{
                show:false
            },
            name: '',
            axisLabel: {
                formatter: '{value} %'
            }
        }
    ],
    series: [{
            type: 'bar',
            barGap: 0,
            label: {
                show: true,
                fontSize: 10,
                position: 'insideBottom'
            }
        },
        {
            type: 'bar',
            label: {
                show: true,
                fontSize: 10,
                position: 'insideBottom'
            }
        },
        {
            type: 'line',
            yAxisIndex: 1,
            smooth: false,
            symbol: 'circle',
            symbolSize: 8,
            label: {
                show: true,
                formatter: '{@同比}%'
            }
        }
    ]
};

export const percentOption={
    color: ['#264D73', '#84B5D5', '#19B3E8','#B0C4DE','#B0E0E6','#A9A9A9','	#B0C4DE'],
    grid: {
        show:false,
        // backgroundColor:'#000',
        left: '3%',
        top:45,
        bottom: 25,
        right: '5%',
        width:'auto',
        // height:300			
    },
    legend: {
        top:20
    },
    title: {
        text: 'Awesome Chart',        
    },
    xAxis: {
        type: 'category',
        axisLabel: {
            interval: 0
        }
    },
    yAxis:{
        show:false
    },
    tooltip:{
        show:true
    },
    // series: [{
    //     type: 'bar',
    //     stack:'占比',
    //      label: {
    //             show: true,
    //             fontSize: 10,
    //             formatter: '{@[1]}%'
    //         }
    // },
    // {
    //     type: 'bar',
    //     stack:'占比',
    //      label: {
    //             show: true,
    //             fontSize: 10,
    //             formatter: '{@[2]}%'
    //         }
    // },
    // {
    //     type: 'bar',
    //     stack:'占比',
    //      label: {
    //             show: true,
    //             fontSize: 10,
    //             formatter: '{@[3]}%'
    //         }
    // }
    // ]
};

export function fillSeries(count){
    let series=[];
    for(let i=1;i<=count;i++){
        series[i-1]={
            type: 'bar',
            barMinHeight:15,
        stack:'占比',
         label: {
                show: true,
                fontSize: 10,
                formatter: '{@['+i+']}%'
            }
        }
    }
    return series;
}
